import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable()
export class MissionsService {
  url: string = environment.url;

  constructor(
    private http: HttpClient
  ) { }

  getVacancyMissions(params): Observable<any> {
    return this.http.get<any>(`${this.url}/missions`, {params: params});
  }

  postVacancyMission(vacancyId, params = {}): Observable<any> {
    return this.http.post<any>(`${this.url}/missions/${vacancyId}`, params);
  }

  getVacancyMissionsWay(params: { vacancyId: string }): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}/missions/way/`, { params });
  }
}
